import React from "react";
import { MasterContainer } from "./styles";
import { useApp } from "@lib/providers";
import { Row } from "./styles";
import { LogoColumn, IconColumn, TextColumn, ButtonColumn, CloseTrayButton, LogoWrapper } from "./styles";

// @ts-ignore
import DelphiniLogo from "@assets/icons/delphini-logo.svg";
// @ts-ignore
import CloseTray from "@assets/icons/close-tray.svg";

export const CommsCenterHeader = () => {
  const { darkMode } = useApp();
  return (
    <MasterContainer>
      <Row darkMode={darkMode}>
        <LogoColumn>
          <LogoWrapper darkMode={darkMode}>
            <DelphiniLogo />
          </LogoWrapper>
        </LogoColumn>
        <TextColumn>Comms Center</TextColumn>
        {/* <ButtonColumn>
          <StrokedIconButton>
            <SlideRightIcon />
            Display Options
          </StrokedIconButton>
        </ButtonColumn> */}
        {/* <IconColumn>
          <CloseTrayButton darkMode={darkMode}>
            <CloseTray />
          </CloseTrayButton>
        </IconColumn> */}
      </Row>
    </MasterContainer>
  );
};
